var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRBoxesStackedDisc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-boxes-stacked-disc",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,-0c11.038,-0 20,8.962 20,20c-0,11.038 -8.962,20 -20,20c-11.038,-0 -20,-8.962 -20,-20c-0,-11.038 8.962,-20 20,-20Zm-3.658,20.166l-5.584,-0c-1.24,-0 -2.245,1.006 -2.245,2.246l-0,4.342c-0,1.239 1.005,2.246 2.245,2.246c0,-0 5.584,-0 5.584,-0c1.239,-0 2.245,-1.007 2.245,-2.246c0,0 0,-4.342 0,-4.342c0,-1.24 -1.006,-2.246 -2.245,-2.246Zm12.9,-0l-5.584,-0c-1.239,-0 -2.245,1.006 -2.245,2.246c-0,-0 -0,4.342 -0,4.342c-0,1.239 1.006,2.246 2.245,2.246c0,-0 5.584,-0 5.584,-0c1.239,-0 2.245,-1.007 2.245,-2.246c0,0 0,-4.342 0,-4.342c0,-1.24 -1.006,-2.246 -2.245,-2.246Zm-13.757,3.176l0,-1.786c0,-0 0.857,-0 0.857,-0c0.474,-0 0.856,0.381 0.856,0.856c-0,-0 -0,4.342 -0,4.342c-0,0.474 -0.382,0.856 -0.856,0.856l-5.584,0c-0.472,0 -0.856,-0.382 -0.856,-0.856l0,-4.342c0,-0.475 0.384,-0.856 0.856,-0.856c0,-0 0.857,-0 0.857,-0c-0,-0 -0,1.786 -0,1.786c-0,0.728 0.588,1.315 1.315,1.315c-0,0 1.24,0 1.24,0c0.728,0 1.315,-0.587 1.315,-1.315Zm12.9,0l0,-1.786c0,-0 0.857,-0 0.857,-0c0.474,-0 0.856,0.381 0.856,0.856c-0,-0 -0,4.342 -0,4.342c-0,0.474 -0.382,0.856 -0.856,0.856l-5.584,0c-0.474,0 -0.856,-0.382 -0.856,-0.856c0,0 0,-4.342 0,-4.342c0,-0.475 0.382,-0.856 0.856,-0.856c0,-0 0.857,-0 0.857,-0c-0,-0 -0,1.786 -0,1.786c-0,0.728 0.587,1.315 1.315,1.315c-0,0 1.24,0 1.24,0c0.728,0 1.315,-0.587 1.315,-1.315Zm-14.289,-1.786l-0,1.712c-0,-0 -1.092,-0 -1.092,-0c0,-0 0,-1.712 0,-1.712l1.092,-0Zm12.9,-0l-0,1.712c-0,-0 -1.092,-0 -1.092,-0l0,-1.712l1.092,-0Zm-1.924,-10.318c0,-1.24 -1.006,-2.245 -2.245,-2.245l-5.583,-0c-1.24,-0 -2.246,1.005 -2.246,2.245c-0,0 -0,4.343 -0,4.343c-0,1.239 1.006,2.245 2.246,2.245c-0,0 5.583,0 5.583,0c1.239,0 2.245,-1.006 2.245,-2.245c0,-0 0,-4.343 0,-4.343Zm-2.245,-0.856c0.474,0 0.856,0.384 0.856,0.856c-0,0 -0,4.343 -0,4.343c-0,0.474 -0.382,0.856 -0.856,0.856c-0,-0 -5.583,-0 -5.583,-0c-0.475,-0 -0.856,-0.382 -0.856,-0.856l-0,-4.343c-0,-0.472 0.381,-0.856 0.856,-0.856c-0,0 0.856,0 0.856,0l-0,1.787c-0,0.726 0.587,1.315 1.315,1.315l1.241,-0c0.727,-0 1.315,-0.589 1.315,-1.315l-0,-1.787c-0,0 0.856,0 0.856,0Zm-3.338,1.712l0,-1.712c0,0 1.092,0 1.092,0c0,0 0,1.712 0,1.712l-1.092,0Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRBoxesStackedDisc);
export default __webpack_public_path__ + "static/media/iconR-boxes-stacked-disc.ad6f82857c0139a4140dd260cb6d3f7b.svg";
export { ForwardRef as ReactComponent };